import { loadMyKitCookie } from "./load-my-kit-cookie";

// Tracker should not broadcast. Read cookie, update UI, done.
export function updateMyKitTracker() {
    const tracker = document.querySelector("[data-header-favourites-tracker]");
    if (!tracker) return;

    const myKit = loadMyKitCookie();
    let total = 0;

    for (const key of Object.keys(myKit || {})) {
        const qty = Number(myKit[key]?.quantity ?? 1);
        total += Number.isFinite(qty) ? qty : 0;
    }

    tracker.innerText = total;
    tracker.dataset.favourites = total > 0 ? "true" : "false";
}
